// Usar variable de entorno o localhost por defecto
export const baseUrlCSRFCookie = process.env.REACT_APP_API_URL || "http://localhost:8000";
export const baseUrl = `${baseUrlCSRFCookie}/api`;